let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("k1CW8")).then(() => parcelRequire('gzIjF'));